import React, {Component} from 'react';
import './Form.css';
import FormErrorMessages from './FormErrorMessages';
import LoadingScreen from './LoadingScreen';

// import Script from 'react-load-script';

class Form extends Component {

  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.autocomplete = null;
    this.addressRef = React.createRef();
    this.cityRef = React.createRef();
    this.zipCodeRef = React.createRef();
    
    this.state = {
      fields: {
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber: '',
        birthDay: '',
        birthMonth: '',
        tvProvider: '',
        agreeEmail: true, 
        agreeText: false,
        panelHeight: 0,
        validatedAddress: '',
        gs_token: null
      },
      isLoading: false,
      errors: {},
      requiredFields: {
        'firstName':'First Name Required', 
        'lastName':'Last Name Required', 
        'email':'Email Required'
      },
      userInitSubmit: false,
      submitForm: false,
      recaptchaPassed: false
    }

    this.formPanel = React.createRef();
  }

  handleSubmit(evt) {
    evt.preventDefault();
    evt.stopPropagation();

    const errors = this.formValidation();

    // this.props.handleSubmit(this.state);
    this.setState({
      userInitSubmit: true,
      isLoading: true,
      errors
    });

  }

  handleFieldChange(evt) {
    const {name, type, value} = evt.target;
    let fieldVal = value;
    
    // console.log('handleFieldChange', (type==='tel' && !!!this.handlePhoneFieldChange(evt) && value), (type!=='checkbox' && value), !this.state.fields[name])
    if (type==='tel') {
      fieldVal = this.handlePhoneFieldChange(value, evt);
    }
    
    if (type==='checkbox') {
      fieldVal = !this.state.fields[name];
    }

    const fields = Object.assign(this.state.fields, {[name]:fieldVal});
    this.setState({fields});
  }
  
  handlePhoneFieldChange(str, evt) {
		//ignore backspace and delete keys
		if (evt.keyCode !== 8 && evt.keyCode !== 46) {
			const val = str.replace(/\D/g,'');
			
      return val.substring(0,3) + '-' + val.substring(3,6) + '-' + val.substring(6,10);
		}
	}

  hasErrors() {
    return Object.keys(this.state.errors).length !== 0;
  }

  setRequiredFieldsError() {
    const {requiredFields, fields} = this.state,
      errors = {},
      fieldsWithErrors = Object.keys(requiredFields).filter(name=>fields[name]==='');

    fieldsWithErrors.forEach(name=>errors[name]=requiredFields[name])

    return errors;
  }

  formValidation(errors) {
    const { fields } = this.state,
      validationErrors = {},
      requiredFieldsErrors = this.setRequiredFieldsError();

    const emptyPhoneField = !fields.phoneNumber || fields.phoneNumber === '--';

    if (!emptyPhoneField && !(/\d{3}-\d{3}-\d{4}/.test(fields.phoneNumber))) {
      validationErrors['phoneNumber'] = 'Incorrect Phone Number format ex. XXX-XXX-XXX';
    }
    
    if (fields.agreeText && emptyPhoneField) {
      validationErrors['phoneNumber'] = 'Phone Number Format Error ex. XXX-XXX-XXX.';
    }
// console.log('formValidation', Object.assign(errors, validationErrors));
    return Object.assign(requiredFieldsErrors, validationErrors);
  }

  backendValidationErrors() {
    const submitError = (this.props.submitError && this.props.submitError.field) || this.state.errors;
    this.setState({errors: submitError});
  }

  // Passed to result panel to set height of result panel
  setFormPanelHeight() {
    const panelHeight = this.formPanel.current.clientHeight,
      fields = Object.assign(this.state.fields, {panelHeight});

    this.setState({fields});
  }

  // populate with local storage data or data returned after backend validation error
  populateWithData() {
    const { data } = this.props;
    const fields = Object.assign({}, data);

    console.log('populateWithData', data, Object.keys(data).length);
    Object.keys(data).length > 0 && this.setState({fields});
  }

  componentDidMount() {
    this.setFormPanelHeight();
    this.populateWithData();

    window.grecaptcha.render('g-recaptcha', {
      'sitekey' : '6LerOY8fAAAAAJxeFHJ4ASYJsHcF9l__SN9ekasb',
      'callback' : resp => this.setState({recaptchaPassed: !!resp, fields: Object.assign(this.state.fields,{gs_token: resp})}),
      'expired-callback' : () => this.setState({recaptchaPassed: false}),
      'size' : 'normal',
    });
  }

  render() {

    const classNames = {
      firstName: 'first-name',
      lastName: 'last-name',
      email: 'email',
      phoneNumber: 'phone-number'
    }

    const {
      errors,
      fields
    } = this.state;

    if (errors) {
      Object.keys(errors).forEach((key)=>{
        classNames[key] += ' error';
      });
    }

    return (
      <div className="submission-form">
        <h3>Enter for a chance to Win!</h3>
        <form action="" method="post">
          <div className="form-fields" ref={this.formPanel}>
            <FormErrorMessages
              errors={errors}
              />
            <fieldset>
              <input className={classNames['firstName']} name="firstName" placeholder="First Name*" onChange={this.handleFieldChange} required value={fields.firstName} />
              <input className={classNames['lastName']} name="lastName" placeholder="Last Name*" onChange={this.handleFieldChange} required value={fields.lastName} />
            </fieldset>
            <fieldset>
              <input type="email" className={classNames['email']} name="email" placeholder="Email*" onChange={this.handleFieldChange} required value={fields.email} />
              <select className="tv-provider" name="tvProvider" onChange={this.handleFieldChange} value={fields.tvProvider} >
                <option value="">Select A Provider</option>
                <option>AT&amp;T U-verse</option>
                <option>Xfinity/Comcast</option>
                <option>Cox Communications</option>
                <option>DirecTV</option>
                <option>DISH Network</option>
                <option>Spectrum</option>
                <option>Optimum</option>
                <option>Suddenlink</option>
                <option>Verizon FiOS</option>
                <option>Frontier Communications</option>
                <option>Rogers</option>
                <option>Shaw</option>
                <option>Other</option>
              </select>
            </fieldset>
            <fieldset>
              <select className={"birth-month" + (fields.birthMonth?' filled':'')} name="birthMonth" onChange={this.handleFieldChange} value={fields.birthMonth} >
                <option value="">Birth Month</option>
                <option value="1">January</option>
                <option value="2">February</option>
                <option value="3">March</option>
                <option value="4">April</option>
                <option value="5">May</option>
                <option value="6">June</option>
                <option value="7">July</option>
                <option value="8">August</option>
                <option value="9">September</option>
                <option value="10">October</option>
                <option value="11">November</option>
                <option value="12">December</option>
              </select>
              <select className={"birth-day" + (fields.birthDay?' filled':'')} name="birthDay" onChange={this.handleFieldChange} value={fields.birthDay} >
                <option value="">Birth Day</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
                <option value="8">8</option>
                <option value="9">9</option>
                <option value="10">10</option>
                <option value="11">11</option>
                <option value="12">12</option>
                <option value="13">13</option>
                <option value="14">14</option>
                <option value="15">15</option>
                <option value="16">16</option>
                <option value="17">17</option>
                <option value="18">18</option>
                <option value="19">19</option>
                <option value="20">20</option>
                <option value="21">21</option>
                <option value="22">22</option>
                <option value="23">23</option>
                <option value="24">24</option>
                <option value="25">25</option>
                <option value="26">26</option>
                <option value="27">27</option>
                <option value="28">28</option>
                <option value="29">29</option>
                <option value="30">30</option>
                <option value="31">31</option>
           </select>
            </fieldset> 
            <fieldset>
              
            </fieldset>
            <div className="recaptcha">
              <div id="g-recaptcha" className="g-recaptcha" data-sitekey="6LerOY8fAAAAAJxeFHJ4ASYJsHcF9l__SN9ekasb"></div>
            </div>
            <div className="legal">
              <p>
              By clicking "Submit" I acknowledge I am 18 years or older and that I understand and agree to the <strong><a href="https://www.gameshownetwork.com/america-says-instant-win-sweepstakes/rules" target="_top">Official Rules</a></strong> and <strong><a href="https://www.gameshownetwork.com/legal/terms" target="_top">Terms of Service</a></strong>.
              </p>
            </div>
            <fieldset className="button">
              <button className="submit" disabled={!this.state.recaptchaPassed} onClick={this.handleSubmit}>Submit</button>
            </fieldset>
            <fieldset>
              <label className="legal">
                <input className="agree-email" type="checkbox" name="agreeEmail" checked={this.state.fields.agreeEmail} onChange={this.handleFieldChange} />
                I would like to receive Game Show Network emails.
              </label>
            </fieldset>
            {/* <div className="legal last">
              <p>
                NO PURCHASE NECESSARY TO ENTER OR WIN.  A PURCHASE WILL NOT IMPROVE YOUR CHANCES OF WINNING.  Promotion consists of an Instant Win Game and a Sweepstakes and begins on or about Saturday, February 18, 2023 at 12:00:01 a.m. Pacific Time (“PT”) and ends on Friday, March 17, 2023 at 11:59:59 p.m. PT.  Must be 18 or older. See <strong>Official Rules at <a href="https://www.gameshownetwork.com/switch/rules" target="_top">https://www.gameshownetwork.com/switch/rules</a></strong> for complete information, including how to enter and play, eligibility restrictions, prize descriptions/restrictions/ARVs and complete details.  Void where prohibited.  Sponsored by Game Show Network, LLC, 2150 Colorado Avenue, Suite 100, Santa Monica, California 90404.  
              </p>
            </div> */}
            {this.state.isLoading &&
              <LoadingScreen />
            }
          </div>
          
        </form>
        {/* <Script 
          url="https://maps.googleapis.com/maps/api/js?key=AIzaSyBYxzlRTHuRxuOLvDShKLQ16rsabTEmcdE&libraries=places"          
          onLoad={this.handlePlacesScriptLoad}        
        />  */}
      </div>
    )
  }

  componentDidUpdate(prevProps, prevState) {
    const that = this;

    if (prevProps.data !== this.props.data) {
      this.populateWithData();
    }

    if (prevProps.submitError!==this.props.submitError) {
      this.setState({isLoading:false});
      this.backendValidationErrors();
    }

    //submitting data to backend
    if (this.state.submitForm === true && prevState.submitForm !== this.state.submitForm) {

      that.props.handleSubmit(that.state.fields);
      that.setState({submitForm: false});
    }

    //check errors before submitting
    if (this.state.userInitSubmit === true && prevState.userInitSubmit !== this.state.userInitSubmit) {
      if (!this.hasErrors()){
        this.setState({submitForm: true});
      } else {
        this.setState({isLoading: false});
      }
      this.setState({userInitSubmit: false});
    } 
  }
}

export default Form;